import { Button, InputController } from '../../components';
import { useAppDispatch } from '../../storeHook';
import { showAlert } from '../../services/alert';
import * as yup from 'yup';
import { useFormWithSchema } from '../../utils/functions/yupFormTypescript';
import {
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { skipToken } from '@reduxjs/toolkit/query';
import { useEffect } from 'react';
import * as regex from '../../utils/constants/regex';
import {
  useGetMinCartLimitDetailsQuery,
  useUpdateMinimumCartValueMutation,
} from '../../services/minCartLimit';

const formSchema = yup.object({
  name: yup.string().required(),
  minimumOrderableValue: yup
    .string()
    .matches(
      regex.INTEGER_NUMBER_GREATER_THAN_0,
      'please enter a integer greater than 0'
    )
    .required('minimum cart value is required'),
});
type TFormData = yup.InferType<typeof formSchema>;

export const EditMinCartLimit: React.FC = () => {
  const navigate = useNavigate();
  const {
    formState: { errors },
    handleSubmit,
    register,
    reset,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
  });

  const [searchParams] = useSearchParams();
  const minCartLimitId = searchParams.get('id');
  const { data: fetchedData } =
    useGetMinCartLimitDetailsQuery(
      minCartLimitId ?? skipToken
    );
  useEffect(() => {
    if (fetchedData) {
      reset({
        name: fetchedData.name,
        minimumOrderableValue:
          fetchedData.minimumOrderableValue.toString(),
      });
    }
  }, [fetchedData]);

  const dispatch = useAppDispatch();
  const [update] = useUpdateMinimumCartValueMutation();
  const onUpdateClick = (data: TFormData) => {
    fetchedData &&
      update({
        ...fetchedData,
        ...data,
        minimumOrderableValue: Number(
          data.minimumOrderableValue
        ),
      })
        .unwrap()
        .then(() => {
          navigate('/min-cart-limit');
          dispatch(
            showAlert({
              content:
                'Minimum cart limit updated successfully',
            })
          );
        })
        .catch((err) => {
          console.log('error', err);
          // this.utility.handleError(err);
        });
  };

  return (
    <form
      onSubmit={handleSubmit((data) => onUpdateClick(data))}
      className="grid grid-cols-2 gap-x-10">
      <InputController
        label="State"
        register={register('name')}
        error={errors.name?.message}
        required
        disabled={!!minCartLimitId}
      />
      <InputController
        label="Minimum Cart Value"
        register={register('minimumOrderableValue')}
        error={errors.minimumOrderableValue?.message}
        required
      />

      <div className="col-span-full form-control mt-8 flex justify-end">
        <Button
          type="button"
          variant="button--secondary"
          onClick={() => navigate('/min-cart-limit')}>
          Cancel
        </Button>
        <Button className="ml-3" type="submit">
          {minCartLimitId ? 'Update' : 'Save'}
        </Button>
      </div>
    </form>
  );
};
